import React from "react";
import "./Button.css";

export default function Button({ variant="primary", size="md", loading=false, icon, children, className="", ...props }) {
  return (
    <button
      className={`btn btn-${variant} btn-${size} ${className}`}
      disabled={loading || props.disabled}
      {...props}
    >
      {loading ? "⏳" : icon ? <span className="btn-icon">{icon}</span> : null}
      <span>{children}</span>
    </button>
  );
}
